import inputFormikFactory from './inputFormikFactory';

export default inputFormikFactory();
